import { search } from "@codemirror/search";
import type { Extension } from "@codemirror/state";
import type { Panel } from "@codemirror/view";

// A hidden panel suppresses CodeMirror's default search UI; the visible search
// bar is rendered separately in the panel chrome via useCodeEditorSearch.
function createHiddenPanel(): Panel {
  const dom = document.createElement("div");
  dom.style.display = "none";
  return { dom, top: true };
}

export function searchExtension(): Extension {
  return search({ top: true, createPanel: createHiddenPanel });
}
